import React from 'react';
import { useFirebaseApp } from '@rainbow-modules/firebase-hooks';
import Avatar from 'react-rainbow-components/components/Avatar';
import MenuDivider from 'react-rainbow-components/components/MenuDivider';
import MenuItem from 'react-rainbow-components/components/MenuItem';
import { UserAvatar, AvatarIcon, UserInfo, UserName, UserDescription } from './styled';
import useUserProfile from '../../hooks/useUserProfile';
import logout from '../../services/logout';
export default function EvertransitAvatar(_ref) {
  var className = _ref.className,
      style = _ref.style;

  var _useUserProfile = useUserProfile(),
      displayName = _useUserProfile.displayName,
      email = _useUserProfile.email,
      photoURL = _useUserProfile.photoURL;

  var app = useFirebaseApp();
  return /*#__PURE__*/React.createElement(UserAvatar, {
    menuAlignment: "right",
    menuSize: "small",
    avatarSize: "large",
    src: photoURL,
    assistiveText: displayName,
    icon: /*#__PURE__*/React.createElement(AvatarIcon, null),
    title: displayName,
    id: "avatar-button",
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(UserInfo, null, /*#__PURE__*/React.createElement(Avatar, {
    assistiveText: displayName,
    title: displayName,
    size: "medium",
    className: "rainbow-m-right_small",
    src: photoURL,
    icon: /*#__PURE__*/React.createElement(AvatarIcon, null)
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserName, null, displayName), /*#__PURE__*/React.createElement(UserDescription, null, email))), /*#__PURE__*/React.createElement(MenuDivider, {
    variant: "space"
  }), /*#__PURE__*/React.createElement(MenuItem, {
    label: "Logout",
    onClick: function onClick() {
      return logout(app);
    }
  }));
}
EvertransitAvatar.defaultProps = {
  className: undefined,
  style: undefined
};